export interface EmojiMapping {
  [id: string]: string;
}

// This is a mapping from the legacy emoji IDs to the native emoji characters.
export const emojiIdToNative: EmojiMapping = {
  ':heart:': '❤️',
  ':clap:': '👏',
  ':thumbsup:': '👍',
  ':ok:': '👌',
  ':rage:': '😡',
  ':angry:': '😠',
  ':sob:': '😭',
  ':cry:': '😢',
  ':white_frowning_face:': '🙁',
  ':thinking_face:': '🤔',
  ':sunglasses:': '😎',
  ':stuck_out_tongue:': '😛',
  ':upside_down_face:': '🙃',
  ':smiley:': '😃',
  ':smile:': '😄',
  ':slightly_smiling_face:': '🙂',
  // The following are the short hand versions of the above emojis.
  '<3': '❤️',
  '&lt;3': '❤️',
  '>:[': '😠',
  '&gt;:[': '😠',
  ":'(": '😢',
  ':&#039;(': '😢',
  ":('": '🙁',
  ':(': '🙁',
  'B)': '😎',
  ':p': '😛',
  ':P': '😛',
  '=D': '😃',
  ':D': '😄',
  ':)': '🙂',
};

// Construct a regex that matches all the emoji IDs.
// This is used to replace the emoji IDs with the native emojis.
export const legacyEmojiRegex = Object.keys(emojiIdToNative)
  .map(pattern => pattern.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
  .join('|');
